import { useEffect, useState } from 'react'

const NATIVE_ONLINE_EVENT = 'rn_isOnline'

export const useOnline = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine)

  const onlineListener = () => setIsOnline(true)
  const offlineListener = () => setIsOnline(false)

  const nativeOnlineListener = (event: Event) => {
    const detail = (event as CustomEvent<{ isOnline?: boolean }>).detail

    if (typeof detail?.isOnline === 'boolean') {
      setIsOnline(detail.isOnline)
    }
  }

  useEffect(() => {
    window.addEventListener('online', onlineListener)
    window.addEventListener('offline', offlineListener)
    document.addEventListener(NATIVE_ONLINE_EVENT, nativeOnlineListener)

    return () => {
      window.removeEventListener('online', onlineListener)
      window.removeEventListener('offline', offlineListener)
      document.removeEventListener(NATIVE_ONLINE_EVENT, nativeOnlineListener)
    }
  }, [])

  return {
    isOnline
  }
}
